import { ref } from 'vue'
import { getValueByPath } from '../../../utils/index'

export function useSeach({
  tableData,
  seachKeys,
  seachMethodProp,
  dataUrl,
  page,
  getData,
  seachData,
}) {
  const seachValue = ref('')
  const seachMethodFn = () => {
    if (seachMethodProp) {
      seachMethodProp(seachValue.value)
    } else if (dataUrl) {
      page.pageNo = 1
      getData(seachValue.value)
    } else {
      const filterData = !seachKeys.length
        ? tableData.value
        : tableData.value.filter((row) => {
            return seachKeys.some((key) => {
              const filedVal = getValueByPath(row, key)
              if (!filedVal && !seachValue.value) {
                return true
              }
              return getValueByPath(row, key)?.indexOf(seachValue.value) > -1
            })
          })
      seachData(filterData)
    }
  }
  return {
    seachValue,
    seachMethodFn,
  }
}
